import * as Common from '@/tenant/common';

export enum accountApiTypes {
  none = 0,
  freee = 1,
  moneyLook = 2,
  smtp =3,
  mfCloud = 4,
}

export enum dealApiTypes {
  none = 0,
  freee = 1,
}

export enum dataMigrationTypes
{
  none = 0,
  yayoi = 1,
  yayoi_item = 2,
  yayoi_stock = 4,
}

export enum yayoiDataMigrationClass
{
  customer = 1,
  supplier = 2,
  receiver = 4,
  warehouse = 8,
  commodity = 16,
  salesDelivery = 32,
  purchaseDelivery = 64,
  stockBalance = 128,
}
export enum apiAccessFlags
{
  none = 0,
  personal = 1,
  powerbi = 2,
}
export class TenantSettings extends Common.ObjectBase{
  constructor(){
    super('TenantSettings')
    this.binders.accountReceivableSales = new Common.ModelBinder(Common.Account);
    this.binders.accountPayablePurchase = new Common.ModelBinder(Common.Account);
    this.binders.accountPayableCharge = new Common.ModelBinder(Common.Account);
    this.binders.accountPurchase = new Common.ModelBinder(Common.Account);
    this.binders.accountSales = new Common.ModelBinder(Common.Account);
    this.binders.accountAdvancePayment = new Common.ModelBinder(Common.Account);
    this.binders.accountAdvanceReceipt = new Common.ModelBinder(Common.Account);
    this.binders.accountTaxPayable = new Common.ModelBinder(Common.Account);
    this.binders.accountTaxReceivable = new Common.ModelBinder(Common.Account);
    this.binders.accountBankCharge = new Common.ModelBinder(Common.Account);
    this.binders.accountCommodity = new Common.ModelBinder(Common.Account);
    this.binders.accountIncomingTransit = new Common.ModelBinder(Common.Account);
    this.binders.accountOutgoingTransit = new Common.ModelBinder(Common.Account);
    this.binders.accountEndInventory = new Common.ModelBinder(Common.Account);
    this.binders.accountQuantityAdjustment = new Common.ModelBinder(Common.Account);          
    this.binders.notificationSettings = new Common.ModelBinder(Common.NotificationSettings) ;             
  }

  public id: number=0;
  public currencyCode: string='';
  public startMonth: number = 1;
  public logRetentionDays: number = 0;
  public dataRetentionDate: Date = null;
  public electronicBookMode: boolean = false;
  public electronicBookDeletable : boolean = false;

  public get electronicBookMode2():number {
    if (this.electronicBookMode == false) return 0;
    else if (this.electronicBookDeletable== false) return 1;
    else return 2;
  }
  public set electronicBookMode2(value:number) {
    if (value == 0) {
      this.electronicBookMode = false;
      this.electronicBookDeletable = false;
    } else if (value == 1){
      this.electronicBookMode = true;
      this.electronicBookDeletable = false;      
    } else if (value == 2){
      this.electronicBookMode = true;
      this.electronicBookDeletable = true;      
    }
  }  
  public noCheckPriceRequired: boolean = false;
  public getTaxCodeForCommodity: boolean = false;
  public purchaseDeliveryPriceChangeFlag: boolean = false;
  public salesDeliveryPriceChangeFlag: boolean = false;
  public noCheckStockShort: boolean = false;
  public invoiceClosingCheck: boolean = false;
  public yearEndClosingFlag: boolean = false;
  public paymentLaterCarryOverTarget: boolean = false;
  public inspectionMode: Common.InspectionModes = 0;
  public commissionMax: number = 0;
  public purchaseDeliveryQuantitySetInitial: boolean = false;
  public deletablePostedMaster:boolean = true;
  public showWorkflowConfirm: boolean = false;
  public allowChangeCommodityCode: boolean = false;
  public allowChangeCounterpartCode: boolean = false;
  public isDisplayUnspecifiedItem: boolean = false;
  public billingSegmentType: number = 0;
  public inputTypeDetailReserveText1: number=0;
  public inputTypeDetailReserveText2: number=0;
  public inputTypeDetailReserveText3: number=0;
  public inputTypeDetailReserveText4: number=0;
  public inputTypeDetailReserveText5: number=0;
  public inputTypeDetailReserveText6: number=0;
  public inputTypeDetailReserveMemo1: number=0;
  public inputTypeDetailReserveMemo2: number=0;
  public inputTypeDetailReserveMemo3: number=0;
  public inputTypeDetailReserveDate1: number=0;
  public inputTypeDetailReserveDate2: number=0;
  public inputTypeDetailReserveDate3: number=0;
  public inputTypeDetailReserveList1: number=0;
  public inputTypeDetailReserveList2: number=0;
  public inputTypeDetailReserveList3: number=0;

  public usedTypeDetailReserveText1: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveText2: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveText3: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveText4: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveText5: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveText6: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveMemo1: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveMemo2: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveMemo3: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveDate1: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveDate2: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveDate3: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveList1: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveList2: UsedTypes =UsedTypes.None;
  public usedTypeDetailReserveList3: UsedTypes =UsedTypes.None;

  public nameReserveText1: string='';
  public nameReserveText2: string='';
  public nameReserveText3: string='';
  public nameReserveText4: string='';
  public nameReserveText5: string='';
  public nameReserveText6: string='';
  public nameReserveMemo1: string='';
  public nameReserveMemo2: string='';
  public nameReserveMemo3: string='';
  public nameReserveDate1: string='';
  public nameReserveDate2: string='';
  public nameReserveDate3: string='';
  public nameReserveList1: string='';
  public nameReserveList2: string='';
  public nameReserveList3: string='';

  public nameCategoryCode1: string = '';
  public nameCategoryCode2: string = '';
  public nameCategoryCode3: string = '';
  public nameCategoryCode4: string = '';
  public nameCategoryCode5: string = '';
  public nameCategoryCode6: string = '';
  public nameCategoryCode11: string = '';
  public nameCategoryCode12: string = '';
  public nameCategoryCode13: string = '';
  public nameCategoryCode14: string = '';
  public nameCategoryCode15: string = '';
  public nameCategoryCode16: string = '';

  // 会計API連携用項目
  public accountApiType: accountApiTypes = null;
  public accountSettingValue: string = null;
  public accountSettingId: string = null;
  public AccountToken: string = null;
  public accountAccessToken: string = null;
  public accountAccessTokenExpire: Date = null;
  public dealApiType: dealApiTypes = null;

  // 入金連携(MoneyLook)設定
  public moneyLookConsumerKey: string = '';
  public lastTransDate: Date = null;
  public cooperateSegment: Common.Segment;
  public unkownDeposit: boolean = false;
  public set viewUukownDeposit(value: boolean){
    if(value == false ) this.dummyCustomer = null;
    this.unkownDeposit = value;
  }
  public get viewUukownDeposit(): boolean{
    return this.unkownDeposit;
  }
  public dummyCustomer: Common.Counterpart;
  public moneyLookAuthenticationDate: Date = null;

  // メール送信設定
  public enableListMenuMail: boolean = false;
  public enableUserSmtp : boolean = false;
  public mailId : string = '';  
  public replyId : string = '';    
  public smtpServer : string = '';
  public smtpPort : number = 0;
  public smtpUid : string = '';
  public smtpPwd : string='';
  public enableSTARTTLS : boolean = false;  

  public get enableUserSmtp2():boolean {return this.enableUserSmtp;}
  public set enableUserSmtp2(value:boolean) {
    this.enableUserSmtp = value;
    if (value == false){
      this.mailId = null;
      this.replyId = null;
      this.smtpServer = null;
      this.smtpPort = 587;
      this.smtpUid = null;
      this.smtpPwd = null;
      this.enableSTARTTLS = false;
    }
  }
  // 基本データ移行
  public dataMigrationType: dataMigrationTypes = null;
  // API連携
  public apiAccessFlag : apiAccessFlags = apiAccessFlags.none;
  public apiKey:string = null;
  public get powerbi():boolean {return (this.apiAccessFlag & apiAccessFlags.powerbi) > 0;}
  public set powerbi(value:boolean) 
  {
    if (value) this.apiAccessFlag = this.apiAccessFlag | apiAccessFlags.powerbi;
    else this.apiAccessFlag = this.apiAccessFlag & ~apiAccessFlags.powerbi;
    //apiキーのクリア
    if (this.apiAccessFlag == 0) this.apiKey = null;
  }

  public accountReceivableSales : Common.Account;
  public accountPayablePurchase : Common.Account;
  public accountPayableCharge : Common.Account;
  public accountPurchase : Common.Account;
  public accountSales : Common.Account;
  public accountAdvancePayment : Common.Account;
  public accountAdvanceReceipt : Common.Account;
  public accountTaxPayable : Common.Account;
  public accountTaxReceivable : Common.Account;
  public accountBankCharge : Common.Account;                  
  public accountCommodity : Common.Account;
  public accountIncomingTransit : Common.Account;
  public accountOutgoingTransit : Common.Account;
  public accountEndInventory : Common.Account;                  
  public accountQuantityAdjustment : Common.Account;                  

  public GetGridItems(commodityAttribute:boolean, stockAttribute:boolean, commodityMemo:boolean, orderMemo:boolean, deliveryMemo:boolean , textPrefix:string = '', initVisible = true){
    var items:Common.GridItemConfiguration[] =[];

    // 未指定項目表示(isDisplayUnspecifiedItem)が未実装のため、マスタ実装時に表示条件を修正
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_text1', 180, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveText1), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_text2', 180, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveText2), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_text3', 180, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveText3), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_text4', 180, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveText4), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_text5', 180, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveText5), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_text6', 180, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveText6), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_memo1', 150, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveMemo1), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_memo2', 150, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveMemo2), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_memo3', 150, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveMemo3), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_date1', 150, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveDate1), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_date2', 150, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveDate2), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_date3', 150, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveDate3), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_list1', 150, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveList1), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_list2', 150, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveList2), initVisible));
    items.push( new Common.GridItemConfiguration(textPrefix + 'reserve_list3', 150, this.IsVisibleUsedType(commodityAttribute, stockAttribute, commodityMemo, orderMemo, deliveryMemo, this.usedTypeDetailReserveList3), initVisible));

  return items;    
  }

  public IsVisibleUsedType(commodityAttribute:boolean, stockAttribute:boolean, commodityMemo:boolean, orderMemo:boolean, deliveryMemo:boolean, usedType: Common.UsedTypes){
    if (commodityAttribute && usedType == Common.UsedTypes.CommodityAttribute)  return true;
    if (stockAttribute && usedType == Common.UsedTypes.StockAttribute)  return true;    
    if (commodityMemo && usedType == Common.UsedTypes.CommodityMemo)  return true;    
    if (orderMemo && usedType == Common.UsedTypes.OrderMemo)  return true;    
    if (deliveryMemo && usedType == Common.UsedTypes.DeliveryMemo)  return true;    
    return false;
  }

  // // テナント設定入力区分廃止後の受発注・入出荷明細一覧の表示用(初期非表示)
  // public GetGridItemConfigurations_invisible(textPrefix:string = ''){
  //   var items:Common.GridItemConfiguration[] =[];
  //   items.push( new Common.GridItemConfiguration(textPrefix + 'テキスト1', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + 'テキスト2', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + 'テキスト3', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + 'テキスト4', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + 'テキスト5', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + 'テキスト6', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + 'メモ1', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + 'メモ2', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + 'メモ3', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + '日付1', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + '日付2', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + '日付3', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + '選択1', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + '選択2', 150, true,false));
  //   items.push( new Common.GridItemConfiguration(textPrefix + '選択3', 150, true,false));
  //   return items;
  // }

  public notificationSettings: NotificationSettings;
}

export enum ExpirationAlertBaseDateTypes{
  None = 0,
  ReserveDate1 = 1,
  ReserveDate2 = 2,
  ReserveDate3 = 3,
}

// 通知設定用の仮想オブジェクト～JSON化して保存する
export class NotificationSettings extends Common.ObjectBase{
  constructor(){
    super('NotificationSettings');    
    this.binders.workflowAllocation = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.workflowComplete = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.salesDeliveryNotice = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.salesInvoiceNotice = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.salesPaymentNotice = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.purchaseDeliveryNotice = new Common.ModelBinder(Common.NotificationSetting);           
    this.binders.purchasePaymentNotice = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.salesDeliveryExpire = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.salesInvoiceExpire = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.salesPaymentExpire = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.purchaseDeliveryExpire = new Common.ModelBinder(Common.NotificationSetting);    
    this.binders.purchasePaymentExpire = new Common.ModelBinder(Common.NotificationSetting);                              
    this.binders.expirationAlertNotification = new Common.ModelBinder(Common.NotificationSetting);
  }
  //在庫補充
  public stockSupplyNotice:NotificationSetting = new NotificationSetting();
  //ワークフロー割当・完了
  public workflowAllocation:NotificationSetting = new NotificationSetting();
  public workflowComplete:NotificationSetting = new NotificationSetting();
  //ワークフロー割当・完了
  public workflowAllocationOfMaster:NotificationSetting = new NotificationSetting();
  public workflowCompleteOfMaster:NotificationSetting = new NotificationSetting();  
  //予定通知
  public salesDeliveryNotice:NotificationSetting = new NotificationSetting();
  public salesInvoiceNotice:NotificationSetting = new NotificationSetting();
  public salesPaymentNotice:NotificationSetting = new NotificationSetting();
  public purchaseDeliveryNotice:NotificationSetting = new NotificationSetting();
  public purchasePaymentNotice:NotificationSetting = new NotificationSetting();
  //期限切れ通知
  public salesDeliveryExpire:NotificationSetting = new NotificationSetting();
  public salesInvoiceExpire:NotificationSetting = new NotificationSetting();
  public salesPaymentExpire:NotificationSetting = new NotificationSetting();
  public purchaseDeliveryExpire:NotificationSetting = new NotificationSetting();
  public purchasePaymentExpire:NotificationSetting = new NotificationSetting();
  //期限アラート通知
  public expirationAlertNotification:NotificationSetting = new NotificationSetting();
  public expirationAlertBaseDate: ExpirationAlertBaseDateTypes = ExpirationAlertBaseDateTypes.None;
  //通知オプション
  public redirectToManager:boolean = true; //所有者未定の場合
  public invoiceWaitingDays:number = 7;//請求処理の猶予期間
  public nonWorkingDays: number;
  public commodityManager: string = '';  // 商品管理者

  public getExpirationAlertBaseDates(tenantSettings:TenantSettings):Common.BindItem[]{
    const items = [new Common.BindItem(ExpirationAlertBaseDateTypes.None, '未選択')];
    // 在庫識別情報に割り当てた商品予備日付だけを基準日の候補にする
    if(tenantSettings.usedTypeDetailReserveDate1 == UsedTypes.StockAttribute) items.push(new Common.BindItem(ExpirationAlertBaseDateTypes.ReserveDate1, tenantSettings.nameReserveDate1));
    if(tenantSettings.usedTypeDetailReserveDate2 == UsedTypes.StockAttribute) items.push(new Common.BindItem(ExpirationAlertBaseDateTypes.ReserveDate2, tenantSettings.nameReserveDate2));
    if(tenantSettings.usedTypeDetailReserveDate3 == UsedTypes.StockAttribute) items.push(new Common.BindItem(ExpirationAlertBaseDateTypes.ReserveDate3, tenantSettings.nameReserveDate3));
    return items;
  }
}

export class NotificationSetting extends Common.ObjectBase{
  constructor(){
    super('NotificationSetting');    
  }
  public enabled: boolean;
  public daysAfter: number =0; //○日後を正とする
  public get daysBefore() {return this.daysAfter ? this.daysAfter * -1 : 0;}
  public set daysBefore(value: number) { this.daysAfter = value ? value * -1 : 0;}
  //通知オプション
  public sendOption: sendOptions = sendOptions.none;
}

export enum sendOptions {
  none = 0,
  pic = 1,
  manager = 2,
  workflowMembers = 4,
  historicalHolders = 8
}

export enum InputTypes {
  None = 0,
  SalesOrder = 1,
  PurchaseOrder = 2,
  PurchaseDelivery = 4,
  SalesDelivery = 8,
  Delivery = PurchaseDelivery | SalesDelivery,
  Order = SalesOrder | PurchaseOrder | PurchaseDelivery | SalesDelivery
}

export enum UsedTypes
{
    None = 0,
    CommodityAttribute = 1,
    StockAttribute = 2,
    OrderMemo = 3,
    DeliveryMemo = 4,
    CommodityMemo = 5
}

export enum BillingSegmentTypes {
  ByCompany = 0,
  BySegment = 1,
}

export class TenantSettingsLoadQuery extends Common.Query {
    constructor(){
        super('TenantSettingsLoadQuery',new Common.ModelBinder(TenantSettings,false));
    }
}
export class GetFreeClientIdQuery extends Common.Query {
  constructor(){
    super('GetFreeClientIdQuery', null);
  }
}
export class GetMfCloudClientIdQuery extends Common.Query {
  constructor(){
    super('GetMfCloudClientIdQuery', null);
  }
}
export class AccountSettingQuery extends Common.Query {
  constructor(){
    super('AccountSettingQuery', new Common.ModelBinder(TenantSettings,false));
  }
  public accountSettingId : string;
  public accountSettingValue : string;
  public accountApiType : Common.accountApiTypes;
  public useDealsApiFreee:boolean;
}
export class FreeCompany extends Common.ObjectBase{
  public id: string;
  public name: string;
  constructor(){
    super('FreeCompany')
  }
}
export class GetFreeeCompaniesQuery extends Common.Query {
  constructor(authCode:string, accountApiType:Common.accountApiTypes){
    super('GetFreeeCompaniesQuery',new Common.ModelBinder(FreeCompany,true));
    this.authCode = authCode;
    this.accountApiType = accountApiType;
  }
    public authCode : string; 
    public accountApiType : Common.accountApiTypes = Common.accountApiTypes.none;
    public accountSettingId : string;
    public accountSettingValue : string;
}
export class MFCloudRequestTokenQuery extends Common.Query {
  constructor(authCode:string){
    super('MFCloudRequestTokenQuery',null);
    this.authCode = authCode;
  }
  public authCode : string;
}
export class YayoiDataMigrationQuery extends Common.Query {
  constructor(dataMigrationType : dataMigrationTypes, importPattern : number){
    super("YayoiDataMigrationQuery",null);
    this.dataMigrationType = dataMigrationType;
    this.importPattern = importPattern;
  }
  public dataMigrationType : dataMigrationTypes;
  public importPattern : number;
  public migrationDataSegment : Common.Segment;
  public migrationDataPic : Common.User;
  public bankAccount : Common.BankAccount;
  public migrationDate : Date;
}
export class GetMoneyLookRequestTokenQuery extends Common.Query{
  constructor(){
    super("GetMoneyLookRequestTokenQuery",null);
  }
  public oauthConsumerKey:string;
  public oauthConsumerSecret:string;
}

export class SetMoneyLookAccessTokenQuery extends Common.Query{
  constructor(){
    super("SetMoneyLookAccessTokenQuery",null);
  }
}
export class DatabaseBackupQuery extends Common.Query{
  constructor(description : string){
    super("DatabaseBackupQuery",null);
    this.description = description;
  }
  public description : string;
}
export class DatabaseBackupDeleteQuery extends Common.Query{
  constructor(deleteFiles : Array<Common.UploadFile>){
    super("DatabaseBackupDeleteQuery",null);
    this.deleteFiles = deleteFiles;
  }
  public deleteFiles : Array<Common.UploadFile>;
}
export class LoaddatabaseBackupFile extends Common.Query{
  constructor(){
    super("LoaddatabaseBackupFile",null);
  }
}
export class RestoreDataBaseQuery extends Common.Query{
  constructor(uploadFile : Common.UploadFile){
    super("RestoreDataBaseQuery",null);
    this.resotoreFile = uploadFile;
  }
  public resotoreFile : Common.UploadFile;
}
export enum SmtpProviderFlags {
  Default = 0,
  Basic = 1,
  Office365 = 2,
  Google =3,
}
export class SmtpSetupQuery extends Common.Query{
  constructor(){
    super("SmtpSetupQuery",new Common.ModelBinder(TenantSettings,false));
  }  
  public  smtpProviderFlag:SmtpProviderFlags = SmtpProviderFlags.Default;
  public  mailId:string = null;
  public  replyId:string= null;
  public  smtpServer :string= null;
  public  smtpPort: Number = 587;
  public  smtpUid :string= null;
  public  smtpPwd:string= null;
  public  enableSTARTTLS:boolean = false;
  public  authorizeCode:string= null;
  public get isBasic() { return this.smtpProviderFlag == SmtpProviderFlags.Basic;}
}